export default [
    {
        path: '/reportData/events',
        name: 'events report data',
        component: () => import('../views/reportData/Events.vue'),
        meta: { claims: [{ name: 'reportsData', crud: 'read' }] }
    },
    {
        path: '/reportData/participants',
        name: 'participants report data',
        component: () => import('../views/reportData/Participants.vue'),
        meta: { claims: [ { name: 'reportsData', crud: 'read' } ] }
    },
]
